import { FiltersReprocessDocumentsModel } from './../models/consult/filters-reprocess-documents.model';
import { TeleconsultaModel }
from '../models/consult/teleconsulta.model';
import { Observable } from 'rxjs';
import { AttentionModel } from '../models/consult/attention.model';
import { GeneralModel } from '../models/consult/general.model';
import { GeneralResponseModel } from '../models/consult/general-response.model';
import { ConsultModel } from '../models/consult/consult.model';
import { ConsultResponseModel } from '../models/consult/consult-response.model';
import { AttentionResponseModel } from '../models/consult/attention-response.model';
import { BackgroundModel } from '../models/consult/background.model';
import { BackgroundResponseModel } from '../models/consult/background-response.model';
import { DiagnosticResponseEntity } from '../../data/repositories/consult/entities/diagnostic-response.entity';
import { DataDiagnosticConsultModel } from '../models/consult/diagnostic-consult.model';
import { RevisionConsultModel } from '../models/consult/revision-consult.model';
import { RevisionResponseEntity } from '../../data/repositories/consult/entities/revision-response.entity';
import { VitalSignsConsultModel } from '../models/consult/vital-signs-consult.model';
import { VitalSignsResponseEntity } from '../../data/repositories/consult/entities/vital-signs-response.entity';
import { OthersConsultModel } from '../models/consult/others-consult.model';
import { OthersResponseEntity } from '../../data/repositories/consult/entities/others-response.entity';
import { DocumentsConsultModel } from '../models/consult/documents-consult.model';
import { DocumentsResponseEntity } from '../../data/repositories/consult/entities/documents-response.entity';
import { TypeDocumentEntity } from '../../data/repositories/configuration/entities/type-document.entity';
import { ConfirmationModel } from '../models/consult/confirmation.model';
import { ConfirmationResponseEntity } from '../../data/repositories/consult/entities/confirmation-response.entity';
import { ReportByDateEntity } from '../../data/repositories/consult/entities/report-by-date.entity';
import { DetalleAtencionEntity } from '../../data/repositories/consult/entities/detalle-atencion.entity';
import { ClientModel } from '../models/client/client.model';
import { StepServiceModel } from '../models/consult/step-service.model';
import { DataInitialModel } from '../models/consult/data-initial.model';
import { DataInitialResponseEntity } from '../../data/repositories/consult/entities/data-initial-response.entity';
import { TypeConsultEntity } from '../../data/repositories/consult/entities/type-consult.entity';
import { DevelopmentModel } from '../models/consult/development.model';
import { DevelopmentResponseEntity } from '../../data/repositories/consult/entities/development-response.entity';
import { ClientEntity } from '../../data/repositories/client/entities/client.entity';
import { TypeDiagnosticEntity } from '../../data/repositories/consult/entities/type-diagnostic.entity';
import { TypeModalityEntity } from '../../data/repositories/consult/entities/type-modality.entity';
import { TypeResidentialAreaEntity } from '../../data/repositories/consult/entities/type-residential-area.entity';
import { TypeIncomeEntity } from '../../data/repositories/consult/entities/type-income.entity';
import { TypeUserEntity } from '../../data/repositories/consult/entities/type-user.entity';
import { TypeModalityModel } from '../models/consult/type-modality.model';
import { ClasificationDiagnosticEntity } from '../../data/repositories/consult/entities/clasification-diagnostic.entity';
import { RipsEntity } from '../../data/repositories/consult/entities/rips-entity';
import { AttentionResumenEntity } from '../../data/repositories/consult/entities/attention-resumen.entity';
import { ElectrocardiogramRhythmEntity } from '../../data/repositories/consult/entities/electrocardiogram-rhythm.entity';
import { ElectrocardiogramWavesEntity } from '../../data/repositories/consult/entities/electrocardiogram-waves.entity';
import { CardiovascularScreeningModel } from '../models/consult/cardiovascular-screening.model';
import { CardiovascularScreeningResponseEntity } from '../../data/repositories/consult/entities/cardiovascular-screening-response.entity';
import { TypeFinalityEntity } from '../../data/repositories/consult/entities/type-finality.entity';
import { TypeCauseEntity } from '../../data/repositories/consult/entities/type-cause.entity';
import { ViaEnterEntity } from '../../data/repositories/consult/entities/via-enter-response.entity';
import { ProcedureModel } from '../models/consult/procedure.model';
import { ProcedureResponseEntity } from '../../data/repositories/consult/entities/procedure-response.entity';
import { ExtensionEntity } from '../../data/repositories/consult/entities/extension.entity';
import { OriginEntity } from '../../data/repositories/consult/entities/origin.entity';
import { InabilityModel } from '../models/consult/inability.model';
import { InabilityResponseEntity } from '../../data/repositories/consult/entities/inability-response.entity';
import { ConsultOptometryModel } from '../models/consult/consult-optometry.model';
import { ConsultOptometryResponseModel } from '../models/consult/consult-optometry-response.model';
import { BackgroundOptometryModel } from '../models/consult/background-optometry.model';
import { BackgroundOptometryResponseModel } from '../models/consult/background-optometry-response.model';
import { TypeGlassesEntity } from '../../data/repositories/consult/entities/type-glasses.entity';
import { TypeFilterGlassesEntity } from '../../data/repositories/consult/entities/type-filter-glasses.entity';
import { TypeMaterialGlassesEntity } from '../../data/repositories/consult/entities/type-material-glasses.entity';
import { LensiometryModel } from '../models/consult/lensiometry.model';
import { LensiometryResponseModel } from '../models/consult/lensiometry-response.model';
import { LensiometryResponseEntity } from '../../data/repositories/consult/entities/lensiometry-response.entity';
import { OftalmoscopyModel } from '../models/consult/oftalmoscopy.model';
import { OftalmoscopyResponseModel } from '../models/consult/oftalmoscopy-response.model';
import { OftalmoscopyResponseEntity } from '../../data/repositories/consult/entities/oftalmoscopy-response.entity';
import { VisualAcuityModel } from '../../data/repositories/consult/entities/visual-acuity.entity';
import { VisualAcuityResponseModel } from '../models/consult/visual-acuity-response.model';
import { VisualAcuityResponseEntity } from '../../data/repositories/consult/entities/visual-acuity-response.entity';
import { DominantEyeEntity } from '../../data/repositories/consult/entities/dominant-eye.entity';
import { TestExternalModel } from '../models/consult/test-external.model';
import { TestExternalResponseModel } from '../models/consult/test-external.response.model';
import { TestExternalResponseEntity } from '../../data/repositories/consult/entities/test-external.response.entity';
import { BiomicroscopyModel } from '../models/consult/biomicroscopy.model';
import { BiomicroscopyResponseEntity } from '../../data/repositories/consult/entities/biomicroscopy-response.entity';
import { BiomicroscopyResponseModel } from '../models/consult/biomicroscopy-response.model';
import { SurfaceFilmModel } from '../models/consult/surface-film.model';
import { SurfaceFilmResponseModel } from '../models/consult/surface-film-response.model';
import { SurfaceFilmResponseEntity } from '../../data/repositories/consult/entities/surface-film-response.entity';
import { DeviationResponseEntity } from '../../data/repositories/consult/entities/deviation-response.entity';
import { DeviationModel } from '../models/consult/deviation.model';
import { DeviationResponseModel } from '../models/consult/deviation-response.model';
import { KerotometryResponseModel } from '../models/consult/kerotometry-response.model';
import { KerotometryModel } from '../models/consult/kerotometry.model';
import { KerotometryResponseEntity } from '../../data/repositories/consult/entities/kerotometry-response.entity';
import { TypeLookEntity } from '../../data/repositories/consult/entities/type-look.entity';
import { TypeRetinoscopyEntity } from '../../data/repositories/consult/entities/type-retinoscopy.entity';
import { RetinoscopyResponseModel } from '../models/consult/retinoscopy-response.model';
import { RetinoscopyModel } from '../models/consult/retinoscopy.model';
import { RetinoscopyResponseEntity } from '../../data/repositories/consult/entities/retinoscopy-response.entity';
import { SubjetiveResponseModel } from '../models/consult/subjetive-response.model';
import { SubjetiveModel } from '../models/consult/subjetive.model';
import { SubjetiveResponseEntity } from '../../data/repositories/consult/entities/subjetive-response.entity';
import { TuningModel } from '../models/consult/tuning.model';
import { TuningResponseModel } from '../models/consult/tuning-response.model';
import { TuningResponseEntity } from '../../data/repositories/consult/entities/tuning-response.entity';
import { PrescriptionModel } from '../models/consult/prescription.model';
import { PrescriptionResponseModel } from '../models/consult/prescription-response.model';
import { PrescriptionResponseEntity } from '../../data/repositories/consult/entities/prescription-response.entity';
import { MotilityResponseModel } from '../models/consult/motility-response.model';
import { MotilityModel } from '../models/consult/motility.model';
import { MotilityResponseEntity } from '../../data/repositories/consult/entities/motility-response.entity';
import { KappaEntity } from '../../data/repositories/consult/entities/kappa.entity';
import { VersionEntity } from '../../data/repositories/consult/entities/version.entity';
import { OthersOptometryModel } from '../models/consult/others-optometry.model';
import { OthersOptometryResponseEntity } from '../../data/repositories/consult/entities/others-optometry-response.entity';
import { TypeBirthEntity } from '../../data/repositories/consult/entities/type-birth.entity';
import { BackgroundNeuropsychologyModel } from '../models/consult/background-neuropsychology.model';
import { BackgroundNeuropsychologyResponseModel } from '../models/consult/background-neuropsychology-response.model';
import { DevelopmentNeuropsychologyModel } from '../models/consult/development-neuropsychology.model';
import { DevelopmentNeuropsychologyResponseEntity } from '../../data/repositories/consult/entities/development-neuropsychology-response.entity';
import { DevelopmentNeuropsychologyResponseModel } from '../models/consult/development-neuropsychology-response.model';
import { HistoryScholNeuropsychologyResponseEntity } from '../../data/repositories/consult/entities/history-schol-neuropsychology-response.entity';
import { HistoryScholNeuropsychologyModel } from '../models/consult/history-schol-neuropsychology.model';
import { HistoryScholNeuropsychologyResponseModel } from '../models/consult/history-schol-neuropsychology-response.model';
import { CompositionNeuropsychologyResponseEntity } from '../../data/repositories/consult/entities/composition-neuropsychology-response.entity';
import { CompositionNeuropsychologyModel } from '../models/consult/composition-neuropsychology.model';
import { CompositionNeuropsychologyResponseModel } from '../models/consult/composition-neuropsychology-response.model';
import { SpasmPhysiotherapyModel } from '../models/consult/spasm-physiotherapy.model';
import { SpasmPhysiotherapyResponseModel } from '../models/consult/spasm-physiotherapy-response.model';
import { SpasmPhysiotherapyResponseEntity } from '../../data/repositories/consult/entities/spasm-physiotherapy-response.entity';
import { RehabilitationPhysiotherapyModel } from '../models/consult/rehabilitation-physiotherapy.model';
import { RehabilitationPhysiotherapyResponseModel } from '../models/consult/rehabilitation-physiotherapy-response.model';
import { RehabilitationPhysiotherapyResponseEntity } from '../../data/repositories/consult/entities/rehabilitation-physiotherapy-response.entity';
import { AffectedAreaPhysiotherapyEntity } from '../../data/repositories/consult/entities/affected-area-physiotherapy.entity';
import { MembersPhysiotherapyEntity } from '../../data/repositories/consult/entities/members-physiotherapy.entity';
import { TypeMuscleEvaluationPhysiotherapyEntity } from '../../data/repositories/consult/entities/type-muscle-evaluation-physiotherapy.entity';
import { MuscleEvaluationPhysiotherapyModel } from '../models/consult/muscle-evaluation-physiotherapy.model';
import { MuscleEvaluationPhysiotherapyResponseModel } from '../models/consult/muscle-evaluation-physiotherapy-response.model';
import { StateArcMotionPhysiotherapyEntity } from '../../data/repositories/consult/entities/state-arc-motion-physiotherapy.entity';
import { ArcMotionPhysiotherapyModel } from '../models/consult/arc-motion.physiotherapy-response.models';
import { ArcMotionPhysiotherapyResponseModel } from '../models/consult/arc-motion-physiotherapy-response.models';
import { ActivityDailyPhysiotherapyEntity } from '../../data/repositories/consult/entities/activity-daily.entity';
import { PainScalePhysiotherapyModel } from '../models/consult/pain-scale-physiotherapy.model';
import { PainScalePhysiotherapyResponseModel } from '../models/consult/pain-scale-physiotherapy-response.model';
import { PainScalePhysiotherapyResponseEntity } from '../../data/repositories/consult/entities/pain-scale-physiotherapy-response.entity';
import { ListPainScalePhysiotherapyEntity } from '../../data/repositories/consult/entities/list-pain-scale-physiotherapy.entity';
import { HealthHabitPhysiotherapyModel } from '../models/consult/health-habit-physiotherapy.model';
import { HealthHabitPhysiotherapyResponseModel } from '../models/consult/health-habit-physiotherapy-response.model';
import { HealthHabitPhysiotherapyResponseEntity } from '../../data/repositories/consult/entities/health-habit-physiotherapy-response.entity';
import { TypeHealthHabitPhysiotherapyEntity } from '../../data/repositories/consult/entities/type-health-habit-physiotherapy.entity';
import { BackgroundPhysiotherapyModel } from '../models/consult/background-physiotherapy.model';
import { BackgroundPhysiotherapyResponseModel } from '../models/consult/background-physiotherapy-response.model';
import { TypeScarPhysiotherapyEntity } from '../../data/repositories/consult/entities/type-scar-physiotherapy.entity';
import { DiagnosticMedicalRehabilityPhysiotherapyModel } from '../models/consult/diagnostic-medical-rehability-physiotherapy.model';
import { DiagnosticMedicalRehabilityPhysiotherapyResponseModel } from '../models/consult/diagnostic-medical-rehability-physiotherapy-response.model';
import { TypeTransferPhysiotherapyEntity } from '../../data/repositories/consult/entities/type-transfer-physiotherapy.entity';
import { TransferPhysiotherapyModel } from '../models/consult/transfer-physiotherapy.model';
import { TransferPhysiotherapyResponseModel } from '../models/consult/transfer-physiotherapy.response.model';
import { AnalysisMarchPhysiotherapyModel } from '../models/consult/analysis-march-physiotherapy.model';
import { AnalysisMarchPhysiotherapyResponseModel } from '../models/consult/analysis-march-physiotherapy-response.model';
import { SpasticityNeurologyEntity } from '../../data/repositories/consult/entities/spasticity-neurology.entity';
import { HypotoniaNeurologyEntity } from '../../data/repositories/consult/entities/hypotonia-neurology.entity';
import { StaticDinamicEquilibriumNeurologyEntity } from '../../data/repositories/consult/entities/static-dinamic-equilibrium-neurology.entity';
import { PlanePostureNeurologyEntity } from '../../data/repositories/consult/entities/plane-posture-neurology.entity';
import { ExplorationNeurologyModel } from '../models/consult/exploration-neurology.model';
import { ExplorationNeurologyResponseModel } from '../models/consult/exploration-neurology-response.model';
import { ConsentResponseEntity } from '../../data/repositories/consult/entities/consent-response.entity';
import { ConsentConsultModel } from '../models/consult/consent.model';
import { TypeAvailableDocumentEntity } from '../../data/repositories/consult/entities/type-available-document.entity';
import { FacturaTerceroModel } from '../models/consult/factura-tercero.model';
import { FacturaTerceroResponseModel } from '../models/consult/factura-tercero-response.model';
import { ConsentResponseModel } from '../models/consult/consent-response.model';
import { VitalSignsMedicalConsultModel } from '../models/consult/vital-signs-medical.consult.model';
import { VitalSignsMedicalResponseEntity } from '../../data/repositories/consult/entities/vital-signs-medical-response.entity';
import { TestFisicalResponseModel } from '../models/consult/test-fisical.response.model';
import { TestFisicalModel } from '../models/consult/test-fisical.model';
import { TestFisicalResponseEntity } from '../../data/repositories/consult/entities/test-fisical.response.entity';
import { TypeStateTestFisicalEntity } from '../../data/repositories/consult/entities/type-state-test-medical.entity';
import { DevelopmentConsultOccupationalTherapyModel } from '../models/consult/development-consult-occupational-therapy.model';
import { DevelopmentConsultOccupationalTherapyResponseModel } from '../models/consult/development-consult-occupational-therapy-response.model';
import { MedicationEntity } from '../models/consult/medications.entity';
import { DoseEntity } from '../../data/repositories/consult/entities/dose.entity';
import { UnitsTimeEntity } from '../../data/repositories/consult/entities/units-time.entity';
import { RoutesAdministrationEntity } from '../../data/repositories/consult/entities/routes-administration.entity';
import { CalculatedFormulaEntity } from '../../data/repositories/consult/entities/calculated-formula.entity';
import { CalculatedFormulaRequestModel } from '../models/consult/calculated-formula-request.model';
import { TypeProcedureEntity } from '../../data/repositories/consult/entities/type-procedure.entity';
import { ProcedureNonSurgicalEntity } from '../../data/repositories/consult/entities/procedure-non-surgical.entity';
import { MedicationRequestModel } from '../models/consult/medication-request.model';
import { ProcedureMedicationResponseModel } from '../models/consult/procedure-medication-response.model';
import { ProcedureAtenttionRequestModel } from '../models/consult/procedure-atenttion-request.model';
import { ProcedureAtenttionEntity } from '../../data/repositories/consult/entities/procedure-atenttion.entity';
import { AttentionResumenModel } from '../models/consult/attention-resumen.model';
import { DataBasicAttentionModel } from '../models/consult/data-basic-atenttion.model';
import { TeleconsultaInsertResponseEntity } from '../../data/repositories/consult/entities/teleconsulta-insert-response.entity';
import { TeleconsultaActivateResponseEntity } from '../../data/repositories/consult/entities/teleconsulta.activate-response.entity';
import { ReprocessDocumentsAttentionResponseEntity } from '../../data/repositories/consult/entities/reprocess-documents-attention-response.entity';
import { ReprocessStartResponseEntity } from '../../data/repositories/consult/entities/reprocess-start-response.entity';
import { ReprocessStartRequestModel } from '../models/consult/reprocess-documents-start-request.model';
import { AttentionStateModel } from '../models/consult/attention-state.model';

export abstract class ConsultRepository {
  abstract getTypeDocuments(): Observable<TypeDocumentEntity>;
  abstract getTypeConsult(idTypeService: string): Observable<TypeConsultEntity>;
  abstract getTypeDiagnostic(): Observable<TypeDiagnosticEntity>;
  abstract getTypeModality(): Observable<TypeModalityEntity>;
  abstract getTypeIncome(): Observable<TypeIncomeEntity>;
  abstract getTypeStateTestFisical(): Observable<TypeStateTestFisicalEntity>;
  abstract getTypeResidentialArea(): Observable<TypeResidentialAreaEntity>;
  abstract getAttentionReportByDate(params: {
    DateInit: Date;
    DateEnd: Date;
    IdEmpresa: string;
  }): Observable<ReportByDateEntity>;
  abstract getDetalleAtencion(params: {
    fechaInicio: Date;
    fechaFin: Date;
  }): Observable<DetalleAtencionEntity>;
  abstract getRipsReportByDate(params: {
    DateInit: Date;
    DateEnd: Date;
    idEnablingsCode: string;
    idNationality: string;
  }): Observable<RipsEntity>;
  abstract getAttentionConsecutive(params: {
    IdAttention: string
  }): Observable<ClientModel>;
  abstract getAttentionDataBasicById(params: {
    IdAttention: string
  }): Observable<DataBasicAttentionModel>;
  abstract getAttentionByStep(params: {
    IdAttention: string , IdStep:string
  }): Observable<AttentionResumenModel>;
  abstract getStepService(params: {
    IdService: string;
  }): Observable<StepServiceModel>;
  abstract getStepService(params: {
    IdService: string;
  }): Observable<StepServiceModel>;
  abstract getTypeModalityById(params: {
    id: string;
  }): Observable<TypeModalityModel>;
  abstract getDocumentsByClient(params: {
    id: string;
  }): Observable<AttentionResumenEntity>;
  abstract getAttentionInProgress(params: {
    idCliente: string;
  }): Observable<AttentionResumenEntity>;
  abstract getLastAttention(params: {
    id: string;
  }): Observable<AttentionResumenEntity>;
  abstract getAttentionAllStates(params: {
    idCliente: string;
  }): Observable<AttentionResumenEntity>;
  abstract getTypeUser(): Observable<TypeUserEntity>;
  abstract getTypeClasificationDiagnostic(): Observable<ClasificationDiagnosticEntity>;
  abstract getElectrocardiogramRhythm(): Observable<ElectrocardiogramRhythmEntity>;
  abstract getElectrocardiogramWaves(): Observable<ElectrocardiogramWavesEntity>;
  abstract getTypeFinality(): Observable<TypeFinalityEntity>;
  abstract getTypeCause(): Observable<TypeCauseEntity>;
  abstract getViaEnter(): Observable<ViaEnterEntity>;
  abstract getOrigin(): Observable<OriginEntity>;
  abstract getExtension(): Observable<ExtensionEntity>;
  abstract getTypeGlasses(): Observable<TypeGlassesEntity>;
  abstract getTypeMaterialGlasses(): Observable<TypeMaterialGlassesEntity>;
  abstract getTypeFilterGlasses(): Observable<TypeFilterGlassesEntity>;
  abstract getDominantEye(): Observable<DominantEyeEntity>;
  abstract getTypeLook(): Observable<TypeLookEntity>;
  abstract getTypeRetinoscopy(): Observable<TypeRetinoscopyEntity>;
  abstract getKappa(): Observable<KappaEntity>;
  abstract getVersion(): Observable<VersionEntity>;
  abstract getTypeBirth(): Observable<TypeBirthEntity>;
  abstract getAffectedAreaPhysiotherapy(): Observable<AffectedAreaPhysiotherapyEntity>;
  abstract getTypeMuscleEvaluationPhysiotherapy(): Observable<TypeMuscleEvaluationPhysiotherapyEntity>;
  abstract getMembersPhysiotherapy(params: {
    idZonaAfectacionMuscular: string;
  }): Observable<MembersPhysiotherapyEntity>;
  abstract getStateArcMotionPhysiotherapy(): Observable<StateArcMotionPhysiotherapyEntity>;
  abstract getActivityDailyPhysiotherapyPhysiotherapy(): Observable<ActivityDailyPhysiotherapyEntity>;
  abstract getListPainScalePhysiotherapy(): Observable<ListPainScalePhysiotherapyEntity>;
  abstract getTypeHealthHabitPhysiotherapy(): Observable<TypeHealthHabitPhysiotherapyEntity>;
  abstract getTypeScarPhysiotherapy(): Observable<TypeScarPhysiotherapyEntity>;
  abstract getTypeTransferPhysiotherapy(): Observable<TypeTransferPhysiotherapyEntity>;
  abstract getSpasticityNeurology(): Observable<SpasticityNeurologyEntity>;
  abstract getHypotoniaNeurology(): Observable<HypotoniaNeurologyEntity>;
  abstract getStaticDinamicEquilibriumNeurology(): Observable<StaticDinamicEquilibriumNeurologyEntity>;
  abstract getPlanePostureNeurology(): Observable<PlanePostureNeurologyEntity>;
  abstract getTypeAvailableDocument(params: {
    idAtencion: string;
  }): Observable<TypeAvailableDocumentEntity>;
  abstract getFacturaTercero(
    params: FacturaTerceroModel
  ): Observable<FacturaTerceroResponseModel>;
  abstract getConsentById(params: {
    idAtencion: string;
    idConsentimientoInformado: string;
  }): Observable<ConsentResponseModel>;
  abstract getConsentPendientById(params: {
    idAtencion: string;
    idConsentimientoInformado: string;
  }): Observable<ConsentResponseModel>;
  abstract getMedications(params: { NombreGenericoDCI: string}): Observable<MedicationEntity>;
  abstract getDose(): Observable<DoseEntity>;
  abstract getUnitsTime(): Observable<UnitsTimeEntity>;
  abstract getRoutesAdministration(): Observable<RoutesAdministrationEntity>;
  abstract getCalculatedFormula(params:CalculatedFormulaRequestModel): Observable<CalculatedFormulaEntity>;
  abstract getTypeProcedure(): Observable<TypeProcedureEntity>;
  abstract getProcedureNonSurgical(params: {id: string, Descripcion:string }): Observable<ProcedureNonSurgicalEntity>;
  abstract insertProcedureMedication(params:MedicationRequestModel): Observable<ProcedureResponseEntity>
  abstract insertProcedureAtenttion( params: ProcedureAtenttionRequestModel): Observable<ProcedureAtenttionEntity>;
  abstract insertAttention(
    params: AttentionModel
  ): Observable<AttentionResponseModel>;
  abstract insertFacturaTercero(
    params: FacturaTerceroModel
  ): Observable<FacturaTerceroResponseModel>;
  abstract insertGeneral(
    params: GeneralModel
  ): Observable<GeneralResponseModel>;
  abstract insertConsult(
    params: ConsultModel
  ): Observable<ConsultResponseModel>;
  abstract insertBackground(
    params: BackgroundModel
  ): Observable<BackgroundResponseModel>;
  abstract insertDiagnostic(
    params: DataDiagnosticConsultModel[]
  ): Observable<DiagnosticResponseEntity>;
  abstract insertRevision(
    params: RevisionConsultModel
  ): Observable<RevisionResponseEntity>;
  abstract insertVitalSigns(
    params: VitalSignsConsultModel
  ): Observable<VitalSignsResponseEntity>;
  abstract insertVitalSignsMedical(
    params: VitalSignsMedicalConsultModel
  ): Observable<VitalSignsMedicalResponseEntity>;
  abstract insertCardioScreening(
    params: CardiovascularScreeningModel
  ): Observable<CardiovascularScreeningResponseEntity>;
  abstract insertOthers(
    params: OthersConsultModel
  ): Observable<OthersResponseEntity>;
  abstract insertDocuments(
    params: DocumentsConsultModel[]
  ): Observable<DocumentsResponseEntity>;
  abstract insertConfirmation(
    params: ConfirmationModel
  ): Observable<ConfirmationResponseEntity>;
  abstract insertDataInitial(
    params: DataInitialModel
  ): Observable<DataInitialResponseEntity>;
  abstract insertDevelopment(
    params: DevelopmentModel
  ): Observable<DevelopmentResponseEntity>;
  abstract insertProcedure(
    params: ProcedureModel
  ): Observable<ProcedureResponseEntity>;
  abstract insertInability(
    params: InabilityModel
  ): Observable<InabilityResponseEntity>;
  abstract insertConsultOptometry(
    params: ConsultOptometryModel
  ): Observable<ConsultOptometryResponseModel>;
  abstract insertBackgroundOptometry(
    params: BackgroundOptometryModel
  ): Observable<BackgroundOptometryResponseModel>;
  abstract insertLensiometry(
    params: LensiometryModel
  ): Observable<LensiometryResponseModel>;
  abstract insertOftalmoscopy(
    params: OftalmoscopyModel
  ): Observable<OftalmoscopyResponseModel>;
  abstract insertVisualAcuity(
    params: VisualAcuityModel
  ): Observable<VisualAcuityResponseModel>;
  abstract insertTestExternal(
    params: TestExternalModel
  ): Observable<TestExternalResponseModel>;
  abstract insertTestFisical(
    params: TestFisicalModel
  ): Observable<TestFisicalResponseModel>;
  abstract insertBiomicroscopy(
    params: BiomicroscopyModel
  ): Observable<BiomicroscopyResponseModel>;
  abstract insertSurfaceFilm(
    params: SurfaceFilmModel
  ): Observable<SurfaceFilmResponseModel>;
  abstract insertDeviation(
    params: DeviationModel
  ): Observable<DeviationResponseModel>;
  abstract insertKerotometry(
    params: KerotometryModel
  ): Observable<KerotometryResponseModel>;
  abstract insertRetinoscopy(
    params: RetinoscopyModel
  ): Observable<RetinoscopyResponseModel>;
  abstract insertSubjetive(
    params: SubjetiveModel
  ): Observable<SubjetiveResponseModel>;
  abstract insertTuning(params: TuningModel): Observable<TuningResponseModel>;
  abstract insertPrescription(
    params: PrescriptionModel
  ): Observable<PrescriptionResponseModel>;
  abstract insertMotility(
    params: MotilityModel
  ): Observable<MotilityResponseModel>;
  abstract insertOthersOptometry(
    params: OthersOptometryModel
  ): Observable<OthersOptometryResponseEntity>;
  abstract insertBackgroundNeuropsychology(
    params: BackgroundNeuropsychologyModel
  ): Observable<BackgroundNeuropsychologyResponseModel>;
  abstract insertDevelopmentNeuropsychology(
    params: DevelopmentNeuropsychologyModel
  ): Observable<DevelopmentNeuropsychologyResponseEntity>;
  abstract insertCompositionNeuropsychology(
    params: CompositionNeuropsychologyModel[]
  ): Observable<CompositionNeuropsychologyResponseEntity>;
  abstract insertHistoryNeuropsychology(
    params: HistoryScholNeuropsychologyModel
  ): Observable<HistoryScholNeuropsychologyResponseEntity>;
  abstract insertSpasmPhysiotherapy(
    params: SpasmPhysiotherapyModel
  ): Observable<SpasmPhysiotherapyResponseModel>;
  abstract insertRehabilitationPhysiotherapy(
    params: RehabilitationPhysiotherapyModel
  ): Observable<RehabilitationPhysiotherapyResponseModel>;
  abstract insertMuscleEvaluationPhysiotherapy(
    params: MuscleEvaluationPhysiotherapyModel[]
  ): Observable<MuscleEvaluationPhysiotherapyResponseModel>;
  abstract insertArcMotionPhysiotherapy(
    params: ArcMotionPhysiotherapyModel
  ): Observable<ArcMotionPhysiotherapyResponseModel>;
  abstract insertPainScalePhysiotherapy(
    params: PainScalePhysiotherapyModel
  ): Observable<PainScalePhysiotherapyResponseModel>;
  abstract insertHealthHabitPhysiotherapy(
    params: HealthHabitPhysiotherapyModel
  ): Observable<HealthHabitPhysiotherapyResponseModel>;
  abstract insertBackgroundPhysiotherapy(
    params: BackgroundPhysiotherapyModel
  ): Observable<BackgroundPhysiotherapyResponseModel>;
  abstract insertDiagnosticMedicalRehabilityPhysiotherapy(
    params: DiagnosticMedicalRehabilityPhysiotherapyModel
  ): Observable<DiagnosticMedicalRehabilityPhysiotherapyResponseModel>;
  abstract insertTransferPhysiotherapy(
    params: TransferPhysiotherapyModel
  ): Observable<TransferPhysiotherapyResponseModel>;
  abstract insertAnalysisMarchPhysiotherapy(
    params: AnalysisMarchPhysiotherapyModel
  ): Observable<AnalysisMarchPhysiotherapyResponseModel>;
  abstract insertExplorationNeurology(
    params: ExplorationNeurologyModel
  ): Observable<ExplorationNeurologyResponseModel>;
  abstract insertDevelopmentConsult(
    params: DevelopmentConsultOccupationalTherapyModel
  ): Observable<DevelopmentConsultOccupationalTherapyResponseModel>;
  abstract updateAttention(
    params: AttentionModel
  ): Observable<AttentionResponseModel>;
  abstract updateGeneral(
    params: GeneralModel
  ): Observable<GeneralResponseModel>;
  abstract updateProcedureMedication(params:MedicationRequestModel):Observable<ProcedureMedicationResponseModel>;
  abstract updateProcedureAtenttion( params: ProcedureAtenttionRequestModel): Observable<ProcedureAtenttionEntity>;
  abstract updateConsult(
    params: ConsultModel
  ): Observable<ConsultResponseModel>;
  abstract updateBackground(
    params: BackgroundModel
  ): Observable<BackgroundResponseModel>;
  abstract updateDiagnostic(
    params: DataDiagnosticConsultModel[]
  ): Observable<DiagnosticResponseEntity>;
  abstract updateRevision(
    params: RevisionConsultModel
  ): Observable<RevisionResponseEntity>;
  abstract updateVitalSigns(
    params: VitalSignsConsultModel
  ): Observable<VitalSignsResponseEntity>;
  abstract updateVitalSignsMedical(
    params: VitalSignsMedicalConsultModel
  ): Observable<VitalSignsMedicalResponseEntity>;
  abstract updateOthers(
    params: OthersConsultModel
  ): Observable<OthersResponseEntity>;
  abstract updateDocuments(
    params: DocumentsConsultModel[]
  ): Observable<DocumentsResponseEntity>;
  abstract updateDataInitial(
    params: DataInitialModel
  ): Observable<DataInitialResponseEntity>;
  abstract updateDevelopment(
    params: DevelopmentModel
  ): Observable<DevelopmentResponseEntity>;
  abstract updateCardioScreening(
    params: CardiovascularScreeningModel
  ): Observable<CardiovascularScreeningResponseEntity>;
  abstract updateProcedure(
    params: ProcedureModel
  ): Observable<ProcedureResponseEntity>;
  abstract updateInability(
    params: InabilityModel
  ): Observable<InabilityResponseEntity>;
  abstract updateConsultOptometry(
    params: ConsultOptometryModel
  ): Observable<ConsultOptometryResponseModel>;
  abstract updateBackgroundOptometry(
    params: BackgroundOptometryModel
  ): Observable<BackgroundOptometryResponseModel>;
  abstract updateLensiometry(
    params: LensiometryModel
  ): Observable<LensiometryResponseEntity>;
  abstract updateOftalmoscopy(
    params: OftalmoscopyModel
  ): Observable<OftalmoscopyResponseEntity>;
  abstract updateVisualAcuity(
    params: VisualAcuityModel
  ): Observable<VisualAcuityResponseEntity>;
  abstract updateTestExternal(
    params: TestExternalModel
  ): Observable<TestExternalResponseEntity>;
  abstract updateTestFisical(
    params: TestFisicalModel
  ): Observable<TestFisicalResponseEntity>;
  abstract updateBiomicroscopy(
    params: BiomicroscopyModel
  ): Observable<BiomicroscopyResponseEntity>;
  abstract updateSurfaceFilm(
    params: BiomicroscopyModel
  ): Observable<SurfaceFilmResponseEntity>;
  abstract updateDeviation(
    params: DeviationModel
  ): Observable<DeviationResponseEntity>;
  abstract updateKerotometry(
    params: KerotometryModel
  ): Observable<KerotometryResponseEntity>;
  abstract updateRetinoscopy(
    params: RetinoscopyModel
  ): Observable<RetinoscopyResponseEntity>;
  abstract updateSubjetive(
    params: SubjetiveModel
  ): Observable<SubjetiveResponseEntity>;
  abstract updatePrescription(
    params: PrescriptionModel
  ): Observable<PrescriptionResponseEntity>;
  abstract updateMotility(
    params: MotilityModel
  ): Observable<MotilityResponseEntity>;
  abstract updateTuning(params: TuningModel): Observable<TuningResponseEntity>;
  abstract updateOthersOptometry(
    params: OthersOptometryModel
  ): Observable<OthersOptometryResponseEntity>;
  abstract updateBackgroundNeuropsychology(
    params: BackgroundNeuropsychologyModel
  ): Observable<BackgroundNeuropsychologyResponseModel>;
  abstract updateDevelopmentNeuropsychology(
    params: DevelopmentNeuropsychologyModel
  ): Observable<DevelopmentNeuropsychologyResponseModel>;
  abstract updateCompositionNeuropsychology(
    params: CompositionNeuropsychologyModel[]
  ): Observable<CompositionNeuropsychologyResponseModel>;
  abstract updateHistoryNeuropsychology(
    params: HistoryScholNeuropsychologyModel
  ): Observable<HistoryScholNeuropsychologyResponseModel>;
  abstract updateSpasmPhysiotherapy(
    params: SpasmPhysiotherapyModel
  ): Observable<SpasmPhysiotherapyResponseEntity>;
  abstract updateRehabilitationPhysiotherapy(
    params: RehabilitationPhysiotherapyModel
  ): Observable<RehabilitationPhysiotherapyResponseEntity>;
  abstract updatePainScalePhysiotherapy(
    params: PainScalePhysiotherapyModel
  ): Observable<PainScalePhysiotherapyResponseEntity>;
  abstract updateHealthHabitPhysiotherapy(
    params: HealthHabitPhysiotherapyModel
  ): Observable<HealthHabitPhysiotherapyResponseEntity>;
  abstract updateBackgroundPhysiotherapy(
    params: BackgroundPhysiotherapyModel
  ): Observable<BackgroundPhysiotherapyResponseModel>;
  abstract updateDiagnosticMedicalRehabilityPhysiotherapy(
    params: DiagnosticMedicalRehabilityPhysiotherapyModel
  ): Observable<DiagnosticMedicalRehabilityPhysiotherapyResponseModel>;
  abstract updateTransferPhysiotherapy(
    params: TransferPhysiotherapyModel
  ): Observable<TransferPhysiotherapyResponseModel>;
  abstract updateAnalysisMarchPhysiotherapy(
    params: AnalysisMarchPhysiotherapyModel
  ): Observable<AnalysisMarchPhysiotherapyResponseModel>;
  abstract updateExplorationNeurology(
    params: ExplorationNeurologyModel
  ): Observable<ExplorationNeurologyResponseModel>;
  abstract updateDevelopmentConsult(
    params: DevelopmentConsultOccupationalTherapyModel
  ): Observable<DevelopmentConsultOccupationalTherapyResponseModel>;
  abstract cancelAttention(params: { id: string }): Observable<ClientEntity>;
  // abstract generateOTPConsent(params: ConsentConsultModel):Observable<ConsentResponseEntity>; eliminar
  // abstract validateOTPConsent(params: ConsentConsultModel):Observable<ConsentResponseEntity>; eliminar
  abstract sendConsent(
    params: ConsentConsultModel
  ): Observable<ConsentResponseEntity>;
  abstract signConsent(
    params: ConsentConsultModel
  ): Observable<ConsentResponseEntity>;
  abstract deleteDocument(params: {
    id: string;
  }): Observable<DocumentsResponseEntity>;
  abstract deleteFamilyComposition(params: {
    id: string;
  }): Observable<CompositionNeuropsychologyResponseEntity>;
  abstract deleteRecordSchol(params: {
    id: string;
  }): Observable<HistoryScholNeuropsychologyResponseEntity>;
  abstract deleteMuscleEvaluationPhysiotherapy(params: {
    id: string;
  }): Observable<MuscleEvaluationPhysiotherapyResponseModel>;
  abstract deleteArcMotionPhysiotherapy(params: {
    id: string;
  }): Observable<ArcMotionPhysiotherapyResponseModel>;
  abstract deleteConsent(params: {
    id: string;
  }): Observable<ConsentResponseEntity>;
  /**HCD */
  abstract createPendingHCDListById(params: { id: string }): Observable<DocumentsResponseEntity>;
  /**Teleconsulta */
  abstract createTeleconsulta(params: { id: string; id2: string;  descripcion: string;
  }): Observable<TeleconsultaInsertResponseEntity>;
  abstract activateTeleconsulta(params: { id: string; descripcion: string;
  }): Observable<TeleconsultaActivateResponseEntity>;
  abstract getTeleconsultaById( params : {idAtencion: string} ):
    Observable<TeleconsultaModel>;
    /*Reproceso Documentos PDF */
  abstract getAttentionReprocess(params: FiltersReprocessDocumentsModel
  ): Observable<ReprocessDocumentsAttentionResponseEntity>;
    abstract activateDocumentReprocess(params: ReprocessStartRequestModel):
     Observable<ReprocessStartResponseEntity>;
 abstract getAttentionState(): Observable<AttentionStateModel>;
}
